import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { QueryFilter } from 'model/essential-types';
import { QueryMemory } from 'support/shared_models/query-memory';

@autoinject
export class DownloadClearFiltersToolbarView {
  private hint: any = undefined;

  constructor(private router: Router, private queryMemory: QueryMemory<QueryFilter>) { }

  bind() {
    this.hint = this.router.currentInstruction.config.settings?.filterHint;
  }
}
